import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import { sourceKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

export const useDeleteSource = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => sourcesApi.deleteSource(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sourceKeys.lists() });
      Notification.success({
        title: 'Fuente eliminada',
        description: 'La fuente se eliminó exitosamente del sistema.',
      });
    },
  });

  return {
    deleteSource: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};
